import clsx from 'clsx'

import styles from './button.module.scss'

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
    isLoading?: boolean
    ref?: React.Ref<HTMLButtonElement>
    size?: 'icon' | 'large' | 'medium' | 'small'
    variant?: 'dark' | 'primary' | 'secondary'
}

export const Button = ({
    variant = 'primary',
    size = 'large',
    isLoading,
    className,
    children,
    ref,
    ...props
}: IButtonProps): React.ReactNode => {
    if (isLoading) {
        return (
            <button
                ref={ref}
                className={clsx(
                    styles.button,
                    styles[`button__${variant}`],
                    styles[`button__${size}`],
                    styles['button_loading'],
                    className,
                )}
                onClick={(event) => {
                    event.preventDefault()
                }}
                {...props}
            >
                <div className='loader' />
            </button>
        )
    }

    return (
        <button
            ref={ref}
            className={clsx(
                styles.button,
                styles[`button__${variant}`],
                styles[`button__${size}`],
                className,
            )}
            {...props}
        >
            {children}
        </button>
    )
}
